/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'summary',
  initialState: {
    items: [],
    period: null,
    from: null,
    to: null
  },
  reducers: {
    update(state, action) {
      state.items = action.payload;
    },
    updateFrom(state, action) {
      state.from = action.payload;
    },
    updateTo(state, action) {
      state.to = action.payload;
    },
    updatePeriod(state, action) {
      state.period = action.payload;
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as summaryAction };
export { reducer as summaryReducer };

/*-------------------------------------------------------------------------------------------*/
